import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'checkbox-circle',
  templateUrl: './checkbox-circle.component.html',
  styleUrls: ['./checkbox-circle.component.scss']
})
export class CheckboxCircleComponent implements OnInit {
  @Input() selected = false;
  @Output() toggled = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  toggle() {
    this.toggled.emit();
  }
}
